import Cookies from 'js-cookie';
import config from 'commons-general/config/index.js';
import { isString } from 'lodash';
import { WindowProxy } from '@sm360/widget-commons-core-services';

import TIME from 'commons-general/constants/time.js';

class CookieService {
    getCurrentDatePlusMillis(millisecondsToAdd) {
        const currentTime = new Date().getTime();

        // eslint-disable-next-line no-restricted-globals
        if (isNaN(millisecondsToAdd)) {
            return new Date(currentTime);
        }

        return new Date(currentTime + millisecondsToAdd);
    }

    /**
     * Get cookie by his name
     * @param {string} name Cookie name
     */
    get(name) {
        if (!isString(name) || !WindowProxy.get()) {
            return null;
        }

        return Cookies.get(name);
    }

    /**
     * Set a cookie with the given informations
     * @param {string} name The name of the Cookie
     * @param {object|string} value The value to set in the cookie
     * @param {?object} options Options for the cookie
     * @see https://github.com/js-cookie/js-cookie/tree/v2.2.0#cookie-attributes
     */
    save(name, value, options) {
        if (WindowProxy.get()) {
            Cookies.set(name, value, options);
        }
    }

    /**
     * DEPRECATED (see {CookieService.get})
     * Get the token with the cookie name
     */
    getToken(tokenName) {
        return this.get(tokenName);
    }

    setToken(tokenName, jwt) {
        const cookieOptions = {
            path: '/',
            expires: this.getCurrentDatePlusMillis(TIME.ACCOUNT.cookieTtlInMilliseconds),
            secure: config.secureCookies,
        };

        this.save(tokenName, jwt, cookieOptions);
    }

    deleteToken(tokenName) {
        if (WindowProxy.get()) {
            Cookies.remove(tokenName, {
                path: '/',
                secure: config.secureCookies,
            });
        }
    }
}

export default new CookieService();



// WEBPACK FOOTER //
// ./src/services/CookieService/CookieService.js